// client/src/api.js
import axios from 'axios';

/**
 * IMPORTANT: Set this to the IP of the machine RUNNING the Node/Express server.
 * If Node is on MICHAEL-PC and its LAN IP is 10.20.40.30, leave as-is.
 * If Node runs on a different PC, change the IP accordingly.
 */
export const API_BASE = '/';

axios.defaults.baseURL = API_BASE;

// attach token if present
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}